import { render, staticRenderFns } from "./AppSettingCPList.vue?vue&type=template&id=d4c58b04&scoped=true"
import script from "./AppSettingCPList.vue?vue&type=script&lang=js"
export * from "./AppSettingCPList.vue?vue&type=script&lang=js"
import style0 from "./AppSettingCPList.vue?vue&type=style&index=0&id=d4c58b04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c58b04",
  null
  
)

export default component.exports